<template>
    <div class="apply">
        <div class="login-kv" v-if="show">
            <img src="/static/banner.jpg" />
        </div>
        <div class="apply_box" v-if="show">
            <div class="apply_top">
                <div class="apply_img">
                    <img src="/static/change.png" />
                </div>
                <div class="apply_title">转诊申请</div>
            </div>
            <div class="apply_btn">
                <van-button color="#FFC34F" class="btn" @click="change('drugstore')">药房转诊</van-button>
                <van-button color="#FFC34F" class="btn" @click="change('hospital')">医院转诊</van-button>
            </div>
        </div>

    </div>
</template>

<script>
    import {
        checkin
    } from "@/api/api";
    import Vue from 'vue';
    import {
        Toast,
        Dialog,
    } from 'vant';

    Vue.use(Toast);

    export default {
        name: "reApply",
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            async init() {
                let {
                    data
                } = await checkin()
                if (!data || !data.papid) {
                    this.show = false
                    Dialog.alert({
                        title: '提示',
                        message: '您当前账号暂未提交患者申请或暂未登录，请前往在线申请提交',
                        confirmButtonColor: '#1E86F0'
                    }).then(() => {
                        this.$wechat.closeWindow()
                    });

                } else {
                    this.$store.commit("setPatientOne", {
                        //存入vuex
                        patientOne: data
                    });
                    this.show = true
                }
            },
            change(value) {

                this.$router.replace({
                    name: "ReChange",
                    query: {
                        value: value
                    }

                })

            },
        }
    }
</script>
<style lang="scss" scoped>
    .apply {
        height: 100%;
        width: 100%;

        .login-kv {
            height: 178px;
            width: 100%;
            margin-bottom: 20px;

            img {
                height: 100%;
                width: 100%;
            }
        }

        .apply_box {
            margin: 0 25px;
            width: auto;
            height: 280px;
            border-radius: 10px;
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
            border: 1px solid rgba(255, 255, 255, 100);
            background: white;
            overflow: hidden;
            display: flex;
            flex-direction: column;

            .apply_top {
                background: #4FAFFF;
                height: 40px;
                width: 100%;
                color: rgba(247, 248, 247, 100);
                font-size: 14px;
                display: flex;
                justify-content: flex-start;
                padding-left: 15px;
                box-sizing: border-box;
                align-items: center;

                .apply_img {
                    height: 24px;
                    width: 24px;
                    margin-right: 11px;

                    img {
                        height: 24px;
                        width: 24px;
                    }
                }


            }

            .apply_btn {
                flex: 1;
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 0 40px;
                box-sizing: border-box;

                .btn {
                    margin: 0;
                    border-radius: 6px;
                }

            }

            .btn:first-child {
                margin-bottom: 20px;
            }

        }

    }
</style>